import { CommonModule } from '@angular/common';
// This Module's Components
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { FlightPlusHotelComponent } from './flight-plus-hotel.component';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    HttpClientModule,
    HttpClientModule
  ],
  declarations: [FlightPlusHotelComponent],
  exports: [FlightPlusHotelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FlightPlusHotelModule {}
